import styles from './Chip.module.scss';

import ClearIcon from '@mui/icons-material/Clear';
import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

export interface ChipProps extends Pick<MuiChipProps, 'color' | 'classes'> {
  label: React.ReactNode;
  caption?: string;
  handleDelete?: () => void;
  onClick?: () => void;
  className?: string;
  maxWidth?: 8 | 18 | false;
  withSeperator?: boolean;
  disabled?: boolean;
  /**
   * The color of the component.
   * @default 'default'
   */
  color?: 'default' | 'primary';
}

export const Chip = (props: ChipProps) => {
  const {
    label,
    caption,
    handleDelete,
    onClick,
    maxWidth = 8,
    withSeperator = true,
    disabled = false,
    color,
  } = props;
  const { t } = useTranslation();
  return (
    <MuiChip
      className={clsx(
        styles.chip,
        props.className,
        styles[`constrained--${maxWidth}`]
      )}
      classes={{ label: styles.label, ...props.classes }}
      deleteIcon={
        handleDelete && <ClearIcon className={styles['clear-icon']} />
      }
      label={
        <>
          <span>{label || t('COMMON.NONE')}</span>
          {caption && (
            <span className={styles.caption}>
              {withSeperator ? <>&nbsp;|&nbsp;</> : <>&nbsp;</>}
              {caption}
            </span>
          )}
        </>
      }
      color={color}
      onDelete={!disabled && handleDelete ? handleDelete : undefined}
      onClick={onClick}
    />
  );
};
